
import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {UserResponse} from "../../classes/user-response";


@Component({
  selector: 'section-break-type',
  templateUrl: './section-break-type.html',
  styleUrls: ['./section-break-type.css'],
  // directives: [RatingComponent]
})
export class SectionBreakComponent implements OnInit{

  //self explanatory

  @Input() question_index : number;
  @Input() question_name : string;
  @Input() question_name_second : string;
  @Input() is_mandt : boolean;
  @Input() question_number : number;
  @Input() indexOfRepeater : number;

  response : string;

  constructor(){
    if(!Boolean(this.question_name_second))
    {
      this.question_name_second = '';
    }
  }

  ngOnInit(){

  }
}


// WEBPACK FOOTER //
// ./src/app/questions-type/section-break-type/section-break-type.ts